"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSubAppDrPicasoDev = exports.loadSubApp = exports.loadSubAppDev = void 0;
const development_renderizers_1 = require("./development.renderizers");
// export const loadDev = async (config: SubAppConfigBase, App: React.FC<any>, setFramework: setFrameworkParamsType): Promise<void> => {
//   if (isWebViewPlatform()) {
//     initializeHybridDev(config, App, setFramework);
//   } else if (isContactCenter()) {
//     initializeCCDev(config, App, setFramework);
//   } else {
//     initializeWebDevelopmentSubApp(config, App, setFramework);
//   }
// };
const loadSubAppDev = async (config, App, setFramework) => {
    (0, development_renderizers_1.initializeWebDevelopmentSubApp)(config, App, setFramework);
};
exports.loadSubAppDev = loadSubAppDev;
const loadSubApp = async (config, App, setFramework) => {
    (0, development_renderizers_1.initializeWebDevelopmentSubApp)(config, App, setFramework);
};
exports.loadSubApp = loadSubApp;
// export const loadUSD = async (config: SubAppConfigBase, App: React.FC<any>, setFramework: setCCFrameworkParamsType): Promise<void> => {
//   initializeCCDev(config, App, setFramework);
// };
// export const loadAssisted = async (config: SubAppConfigBase, App: React.FC<any>, setFramework: setCCFrameworkParamsType): Promise<void> => {
//   initializeCCDev(config, App, setFramework);
// };
const loadSubAppDrPicasoDev = async (config, App, setFramework) => {
    (0, development_renderizers_1.initializeDrPicasoDevelopmentSubApp)(config, App, setFramework);
};
exports.loadSubAppDrPicasoDev = loadSubAppDrPicasoDev;
//# sourceMappingURL=development.loaders.js.map